export default function ({ type, name, ext = '', landing = null }) {
    const background = name => ({
        ext: ext || 'jpg',
        folder: 'backgrounds',
        name
    })

    const icon = name =>
        landing.getImgUrl({
            ext: 'svg',
            folder: 'icons',
            name
        })

    const visual = name => ({
        ext: ext || 'png',
        folder: 'visuals',
        name
    })

    const types = {
        background,
        icon,
        visual
    }

    return types[type](name)
}
